import "./AddManufacturer.scss";
import React, { useState, useRef } from "react";

function AddManufacturer() {
  const [manufacturerName, setManufacturerName] = useState("");
  const [manufacturerLogo, setManufacturerLogo] = useState(""); // preview only
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setManufacturerLogo(URL.createObjectURL(file)); // preview
    }
  };

  const handleSelectImage = () => {
    fileInputRef.current.click();
  };

  const handleSave = () => {
    try {
      const formData = new FormData();
      formData.append("subFolderName", manufacturerName);
      formData.append("manufacturerName", manufacturerName);
      if (selectedFile) {
        formData.append("manufacturerLogo", selectedFile); // ✅ append file itself
      }

      fetch(`${process.env.REACT_APP_BASE_URL}api/product/add-manufacturer`, {
        method: "POST",
        body: formData, // ✅ no headers, browser sets them
      })
        .then((res) => res.json())
        .then((data) => {
          //console.log("Manufacturer saved successfully:", data);
          alert("Manufacturer saved successfully!!");
          handleCancel();
        })
        .catch((err) => console.error("Error saving Manufacturer:", err));
    } catch (err) {
      console.error("Upload error:", err.message);
      alert("Internal server error.");
    }
  };

  const handleCancel = () => {
    setManufacturerName("");
    setSelectedFile(null);
    setManufacturerLogo("");
    if (fileInputRef.current) fileInputRef.current.value = ""; // clear input
  };
  return (
    <div className="am-container">
      <div className="am-input-wrapper">
        <label>Manufacturer Name:</label>
        <input
          type="text"
          value={manufacturerName}
          onChange={(e) => setManufacturerName(e.target.value)}
        />
      </div>
      <div className="am-input-wrapper">
        <button onClick={handleSelectImage}>UPLOAD IMAGE</button>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept=".jpg,.jpeg,.png"
          onChange={handleFileChange}
        />
        <p>FILE EXTENSION: .JPG, .JPEG, .PNG</p>

        {manufacturerLogo && <img src={manufacturerLogo} alt="Preview" />}
      </div>
      <div className="am-btn-action-wrapper">
        <button className="cancel-btn" onClick={() => setManufacturerName("")}>
          Cancel
        </button>
        <button className="save-btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
}

export default AddManufacturer;
